export enum TARIFF_CONSENT_STATUS {
  APPROVED = 'APPROVED',
  OPEN = 'OPEN',
  ERROR = 'ERROR',
}
